import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LoginPageComponent } from './authentication/login-page/login-page.component';
import { LaunchPageComponent } from './launch/launch-page/launch-page.component';
import { ContentLayoutComponent } from './shared/layouts/content-layout/content-layout.component';
import { FullLayoutComponent } from './shared/layouts/full-layout/full-layout.component';
import { COUNTENT_ROUTES } from './shared/routes/content.routes';
import { Full_Content_Routes } from './shared/routes/full.routes';
import { HoriFullLayoutComponent } from './shared/layouts-horizontal/hori-full-layout/hori-full-layout.component';
import { AuthGuard } from './auth/auth.guards';
import { WalktestLaunchPageComponent } from './launch/walktest-launch-page/walktest-launch-page';
// import { LocationStrategy, PathLocationStrategy } from '@angular/common';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full'},
  { path: 'login', component: LoginPageComponent},
  { path: '-live-walk-test', component: WalktestLaunchPageComponent},
  { path: 'firstpage', component: LaunchPageComponent},
  { path: 'firstpage/:name', component: LaunchPageComponent},
  { path: '', component: FullLayoutComponent, children: Full_Content_Routes },
//   { path: 'layout', 
//   loadChildren: () =>
//   import("../app/shared/layouts/full-layout/fulll-layout.module").then(m => m.FullLayoutModule)
// },
  // { path: '', component: HoriFullLayoutComponent, children: Full_Content_Routes}, ,canActivate: [AuthGuard]
  { path: '', component: ContentLayoutComponent, children: COUNTENT_ROUTES  },
  // { path: "**", component: Error404Component, data: { title: "Page Not Found" } },

];
 
@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true, enableTracing: false, preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule],
  // providers: [ {provide: LocationStrategy, useClass: PathLocationStrategy} ]
})
export class AppRoutingModule { }
 